import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import SectionLabel from "../components/SectionLabel";
import { PRODUCTS, MEDIA } from "../data/content";

const Products = () => {
  return (
    <>
      <section
        className="border-b border-[var(--sifra-line)] bg-white"
        data-testid="products-hero"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <SectionLabel>Products & Solutions</SectionLabel>
            <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter mt-6 leading-[1]">
              Ten categories.
              <br />
              Thousands of certified options.
            </h1>
          </div>
          <div className="md:col-span-4 text-[var(--sifra-ink-soft)]">
            Every product we supply is genuine, warrantied and sourced directly
            from leading global brands — Intel, Dell, HP, Lenovo, Seagate,
            Samsung, Sony, LG, Kingston, Asus, Toshiba and more.
          </div>
        </div>
      </section>

      <section
        className="bg-[var(--sifra-bg)] border-b border-[var(--sifra-line)]"
        data-testid="products-grid"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-[var(--sifra-line)] bg-white">
            {PRODUCTS.map((p, i) => (
              <div
                key={p.title}
                data-testid={`product-card-${i}`}
                className="border-r border-b border-[var(--sifra-line)] p-8 md:p-10 min-h-[280px] flex flex-col justify-between hover:bg-[var(--sifra-ink)] hover:text-white transition-colors duration-500 group cursor-default"
              >
                <div>
                  <div className="text-[11px] tracking-label uppercase text-[var(--sifra-ink-mute)] group-hover:text-white/60 mb-4">
                    P / {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="font-display font-black text-2xl md:text-3xl tracking-tighter mb-4">
                    {p.title}
                  </div>
                  <p className="text-sm text-[var(--sifra-ink-soft)] group-hover:text-white/70 leading-relaxed">
                    {p.note}
                  </p>
                </div>
                <div className="mt-8 pt-6 border-t border-[var(--sifra-line)] group-hover:border-white/20 transition-colors">
                  <div className="text-[10px] tracking-label uppercase text-[var(--sifra-ink-mute)] group-hover:text-white/60">
                    Supported Brands
                  </div>
                  <div className="text-sm font-semibold mt-1">{p.brands}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white" data-testid="products-banner">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-7 border border-[var(--sifra-line)] overflow-hidden aspect-[16/10]">
              <img
                src={MEDIA.laptop}
                alt="Business laptop"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="md:col-span-5 border border-[var(--sifra-ink)] p-10 flex flex-col justify-between">
              <div>
                <SectionLabel>Need something specific?</SectionLabel>
                <h3 className="font-display font-black text-2xl md:text-3xl tracking-tighter mt-4">
                  Custom builds, bulk orders and enterprise roll-outs — we handle it end to end.
                </h3>
              </div>
              <Link
                to="/contact"
                data-testid="products-cta-quote"
                className="mt-8 inline-flex items-center gap-2 bg-[var(--sifra-ink)] text-white px-6 py-4 text-xs tracking-label font-semibold uppercase hover:bg-[var(--sifra-accent)] transition-colors w-fit"
              >
                Request Quote <ArrowUpRight size={14} weight="bold" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Products;
